<template>
  <div>
    <div class="vx-row">
      <div class="vx-col md:w-9/12 w-full">
        <vx-card class="mb-base" :title="$t('Edicion')" v-if="canEdit" >
          <edit-invoice :invoice="invoice" ></edit-invoice>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import EditInvoice from '../components/Invoices/EditInvoice';
import {mapActions, mapGetters} from 'vuex';

export default {
  components: {
    EditInvoice
  },
  created () {
    this.getInvoice({ id: this.$route.params.id, language: this.language});
  },
  computed: {
    ...mapGetters({
      invoice: 'getInvoice',
      language: 'getCurrentLanguage'
    }),
    canEdit () {
      if (Object.keys(this.invoice).length > 0) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions({
      getInvoice: 'getInvoice',
    })
  }
}

</script>

<style>

</style>
